﻿$.fn.dxCtrlBuilderEmailStyleBordure = function custom_dxCtrlBuilderEmailStyleBordure(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylebordure dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleBordure(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleBordure = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        var $Table = $("<table style='width:100%;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        var dxBtDefaut = $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-text-slash",
            disabled: (option.borderWidth.length == 0),
            onClick: function (e) {
                dxLargeur.option("value", 0)
                dxLargeur.option("value", parseInt(""))
                dxLargeur.repaint()
            },
            onContentReady: function (e) {
                e.element.css("opacity", ((option.borderWidth.length == 0) ? "0.3" : 1))
            }
        }).dxCtrlButton("instance")

        if (!option.allowDefaut) $Td.hide()
        var timeOutSlider = null
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var dxLargeur = $("<div/>").appendTo($Td).dxSlider({
            min: 0,
            value: parseInt(option.borderWidth.toString().replace("px", "")),
            onValueChanged: function (e) {
                window.clearTimeout(timeOutSlider)
                timeOutSlider = window.setTimeout(function () {
                    var newValue = ((isNaN(e.value) ? "" : e.value + "px"))
                    if (newValue.toString().length == 0) {
                        dxBtDefaut.option("disabled", true)
                        dxBtDefaut.component().element().css("opacity", "0.3")
                    } else {
                        dxBtDefaut.option("disabled", false)
                        dxBtDefaut.component().element().css("opacity", "1")
                    }
                    option.onValueChanged({ values: [{ prop: "border-width", value: newValue, oldValue: option.borderWidth }] })
                    option.borderWidth = newValue
                }, 1000)
            },
            tooltip: {
                enabled: true,
                format(value) {
                    var valueDisplay = value
                    if (isNaN(valueDisplay)) { return `Taille: Défaut`; }
                    else { return `Taille: ${value}px`; }
                },
                showMode: 'always',
                position: 'bottom',
            },
            onContentReady: function (e) { window.setTimeout(function () { e.component.repaint() }, 0) }
        }).dxSlider("instance")

        $("<div/>").appendTo(container).dxCtrlBuilderEmailStyleBordureStyle({
            value: option.borderStyle,
            allowDefaut: option.allowDefaut,
            onValueChanged: function (e) {
                option.onValueChanged(e)
            }
        })

        $("<div  style='margin:5px 0;'/>").appendTo(container).dxCtrlColorPicker({
            value: option.borderColor,
            title: "Couleur bordure",
            titlePaletteSelect: "Couleur dans votre email",
            getPaletteSelect: option.dxBuilderEmailPage.mGetLstColor,
            onValueChanged: function (e) {
                var newValue = e.value;
                option.onValueChanged({ values: [{ prop: "border-color", value: newValue, oldValue: option.borderColor }] })
                option.borderColor = newValue
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}